import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Header from './components/Header.jsx'
import Footer from './components/Footer.jsx'
import ScrollToTop from './components/ScrollToTop.jsx'
import BackToTopButton from './components/BackToTopButton.jsx'
import LandingPage from './pages/LandingPage.jsx'
import OrderComingSoon from './pages/OrderComingSoon.jsx'
import Catering from './pages/Catering.jsx'

function App() {
  const { i18n } = useTranslation()

  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return (
    <div className="app-shell">
      <ScrollToTop />
      <Header />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/order" element={<OrderComingSoon />} />
          <Route path="/catering" element={<Catering />} />
        </Routes>
      </main>
      <Footer />
      <BackToTopButton />
    </div>
  )
}

export default App
